import script from "./ReportStatusDropdownItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportStatusDropdownItem.vue?vue&type=script&setup=true&lang=ts"

import "./ReportStatusDropdownItem.vue?vue&type=style&index=0&id=15318e18&lang=scss"

const __exports__ = script;

export default __exports__